import type { CSSProperties, PropsWithChildren } from 'react';

import classNames from 'classnames';

import * as styles from './EmptyState.css';

type Props = PropsWithChildren<{
  backgroundColor: CSSProperties['backgroundColor'];
  textColor: CSSProperties['color'];
  padding: CSSProperties['padding'];
  fontSize?: CSSProperties['fontSize'];
}>;

const EmptyState = ({ backgroundColor, textColor, padding, fontSize, children }: Props) => {
  return (
    <div
      style={
        {
          backgroundColor,
          color: textColor,
          padding,
          fontSize,
        } as CSSProperties
      }
      className={classNames(styles.container)}
    >
      {children}
    </div>
  );
};

export { EmptyState };
